import React from "react";
import { healthDisclaimer, quizNote, socialDisclaimer } from "../data/legal";
import { LegalTab } from "./LegalModal";
export function Footer({
  onOpenLegal
}: {
  onOpenLegal: (tab: LegalTab) => void;
}) {
  return <footer className="mt-12 border-t border-blush-100 bg-cream-dark/60" data-id="element-49" data-mp="32ovukn0cqfgg">
      <div className="mx-auto max-w-4xl space-y-2.5 px-4 py-6 text-[10px] leading-relaxed text-cocoa-soft sm:px-6" data-id="element-50" data-mp="36oxzr65apr0h">
        <p data-id="element-51" data-mp="3ues8bbil0tex">{quizNote}</p>
        <p data-id="element-52" data-mp="3ufju5umdncs0">
          <strong className="font-semibold" data-id="element-53" data-mp="3uftqdzy0mg65">Descargo de Responsabilidad de Salud (Health Disclaimer):</strong> «
          {healthDisclaimer[0]}
        </p>
        <p data-id="element-54" data-mp="3lf56wppurnlv">{healthDisclaimer[1]}»</p>
        <p data-id="element-55" data-mp="3le2jirrqo3ap">
          <strong className="font-semibold" data-id="element-56" data-mp="3lggb2qn7mxdi">Descargo de Responsabilidad de Plataformas (Social Media Disclaimer):</strong> «
          {socialDisclaimer}»
        </p>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 pt-1" data-id="element-57" data-mp="29ydw5zakp29d">
          <span data-id="element-58" data-mp="2eyt9iquuu9rc">© {new Date().getFullYear()} Mi Cocina Natural</span>
          <span aria-hidden="true" data-id="element-59" data-mp="2evxbz3mx5n3f">·</span>
          <button type="button" onClick={() => onOpenLegal("privacy")} className="underline underline-offset-2 hover:text-cocoa" data-id="element-60" data-mp="3lalhljipadw2">
            Políticas de Privacidad
          </button>
          <span aria-hidden="true" data-id="element-61" data-mp="3v89fgibls1ig">·</span>
          <button type="button" onClick={() => onOpenLegal("terms")} className="underline underline-offset-2 hover:text-cocoa" data-id="element-62" data-mp="3v9193nln3p63">
            Términos de Uso
          </button>
        </div>
      </div>
    </footer>;
}